/* FEVAWEAR theme JS: drawers, ajax cart, product form, reveals */
(function () {
  'use strict';

  /* ---------- helpers ---------- */

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var pattern = /\{\{\s*(\w+)\s*\}\}/;
    var f = format || window.theme.moneyFormat || '${{amount}}';
    function withDelimiters(num, thousands, decimal) {
      var parts = num.split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }
    var match = f.match(pattern);
    var key = match ? match[1] : 'amount';
    var out;
    switch (key) {
      case 'amount_no_decimals':
        out = withDelimiters(Math.round(cents / 100).toString(), ',', '.');
        break;
      case 'amount_with_comma_separator':
        out = withDelimiters(value, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        out = withDelimiters(Math.round(cents / 100).toString(), '.', ',');
        break;
      default:
        out = withDelimiters(value, ',', '.');
    }
    return f.replace(pattern, out);
  }

  var overlay = document.querySelector('[data-overlay]');

  function openPanel(panel) {
    if (!panel) return;
    panel.classList.add('is-open');
    if (overlay) {
      overlay.hidden = false;
      requestAnimationFrame(function () { overlay.classList.add('is-active'); });
    }
    document.documentElement.style.overflow = 'hidden';
  }

  function closePanels() {
    document.querySelectorAll('.menu-drawer.is-open, .cart-drawer.is-open').forEach(function (p) {
      p.classList.remove('is-open');
    });
    if (overlay) {
      overlay.classList.remove('is-active');
      setTimeout(function () { overlay.hidden = true; }, 300);
    }
    document.documentElement.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-overlay]') || e.target.closest('[data-close-panel]')) closePanels();
    if (e.target.closest('[data-open-menu]')) { e.preventDefault(); openPanel(document.querySelector('.menu-drawer')); }
    if (e.target.closest('[data-open-cart]')) { e.preventDefault(); openPanel(document.querySelector('.cart-drawer')); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closePanels();
  });

  /* ---------- cart ---------- */

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-count', count);
    });
  }

  function refreshCartDrawer(openAfter) {
    return fetch(window.location.pathname + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var html = sections['cart-drawer'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.cart-drawer');
        var current = document.querySelector('.cart-drawer');
        if (fresh && current) {
          var wasOpen = current.classList.contains('is-open');
          current.innerHTML = fresh.innerHTML;
          if (wasOpen) current.classList.add('is-open');
        }
        return fetch(window.theme.routes.cart + '.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            updateCartCount(cart.item_count);
            if (openAfter) openPanel(document.querySelector('.cart-drawer'));
          });
      });
  }

  /* add to cart (product forms flagged with data-ajax-cart) */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.querySelector('[data-btn-label]') : null;
    var original = label ? label.textContent : '';
    if (label) label.textContent = '...';

    fetch(window.theme.routes.cartAdd + '.js', {
      method: 'POST',
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          if (label) label.textContent = res.data.description || res.data.message || 'Error';
          setTimeout(function () { if (label) label.textContent = original; }, 2500);
          return;
        }
        if (label) label.textContent = original;
        refreshCartDrawer(true);
      })
      .catch(function () { if (label) label.textContent = original; });
  });

  /* line quantity / remove (works in drawer and cart page) */
  document.addEventListener('click', function (e) {
    var changeBtn = e.target.closest('[data-line-change]');
    var removeBtn = e.target.closest('[data-line-remove]');
    if (!changeBtn && !removeBtn) return;
    e.preventDefault();
    var el = changeBtn || removeBtn;
    var line = parseInt(el.getAttribute('data-line'), 10);
    var qty = 0;
    if (changeBtn) {
      var input = el.closest('.qty').querySelector('input');
      qty = Math.max(0, parseInt(input.value, 10) + parseInt(el.getAttribute('data-line-change'), 10));
    }
    fetch(window.theme.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
        } else {
          refreshCartDrawer(false);
          updateCartCount(cart.item_count);
        }
      });
  });

  /* ---------- product form: variants ---------- */

  document.querySelectorAll('[data-product-form]').forEach(function (wrap) {
    var dataEl = wrap.querySelector('[data-variants-json]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = wrap.querySelector('input[name="id"]');
    var priceEl = wrap.querySelector('[data-price]');
    var btn = wrap.querySelector('[data-add-btn]');
    var label = btn ? btn.querySelector('[data-btn-label]') : null;
    var lowEl = wrap.querySelector('[data-low-stock]');
    var lowThreshold = parseInt(wrap.getAttribute('data-low-stock-threshold') || '0', 10);

    function selectedOptions() {
      var opts = [];
      wrap.querySelectorAll('.variant-fieldset').forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        opts.push(checked ? checked.value : null);
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function render() {
      var variant = findVariant(selectedOptions());
      wrap.querySelectorAll('[data-option-value]').forEach(function (el) {
        var fs = el.closest('.variant-fieldset');
        var checked = fs.querySelector('input:checked');
        el.textContent = checked ? checked.value : '';
      });
      if (!variant) {
        if (btn) btn.disabled = true;
        if (label) label.textContent = window.theme.strings.unavailable;
        if (lowEl) lowEl.hidden = true;
        return;
      }
      if (lowEl) {
        lowEl.hidden = !(
          lowThreshold > 0 &&
          variant.available &&
          variant.inventory_management &&
          typeof variant.inventory_quantity === 'number' &&
          variant.inventory_quantity > 0 &&
          variant.inventory_quantity <= lowThreshold
        );
      }
      idInput.value = variant.id;
      if (priceEl) {
        var html = formatMoney(variant.price);
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html = '<span class="price__sale">' + formatMoney(variant.price) + '</span>' +
                 '<s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s>';
        }
        priceEl.innerHTML = html;
      }
      if (btn) {
        btn.disabled = !variant.available;
        if (label) label.textContent = variant.available ? window.theme.strings.addToCart : window.theme.strings.soldOut;
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    wrap.querySelectorAll('.variant-fieldset input').forEach(function (input) {
      input.addEventListener('change', render);
    });
  });

  /* qty +/- (product page, not cart lines) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn || btn.hasAttribute('data-line-change')) return;
    var input = btn.closest('.qty').querySelector('input');
    var next = parseInt(input.value, 10) + parseInt(btn.getAttribute('data-qty-change'), 10);
    input.value = Math.max(1, next);
  });

  /* ---------- product gallery thumbs + tabs ---------- */

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (thumb) {
      var productEl = thumb.closest('.product');
      var index = thumb.getAttribute('data-index');
      productEl.querySelectorAll('[data-thumb]').forEach(function (t) {
        t.classList.toggle('is-active', t === thumb);
      });
      productEl.querySelectorAll('[data-media]').forEach(function (m) {
        m.classList.toggle('is-active', m.getAttribute('data-index') === index);
      });
    }

    var tabBtn = e.target.closest('[data-tab]');
    if (tabBtn) {
      var tabs = tabBtn.closest('[data-tabs]');
      var id = tabBtn.getAttribute('data-tab');
      tabs.querySelectorAll('[data-tab]').forEach(function (b) {
        b.classList.toggle('is-active', b === tabBtn);
      });
      tabs.querySelectorAll('[data-tab-panel]').forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-tab-panel') === id);
      });
    }
  });

  /* ---------- language switcher ---------- */

  document.addEventListener('change', function (e) {
    var localeSelect = e.target.closest('[data-locale-select]');
    if (localeSelect) localeSelect.closest('form').submit();
  });

  /* ---------- collection sort ---------- */

  document.querySelectorAll('[data-sort-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* ---------- scroll reveal ---------- */

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
  }
})();
